import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import ContractRecommendation from '../components/ContractRecommendation';

const RecommendPage = () => {
  return (
    <div className="min-h-screen mesh-gradient">
      {/* Header */}
      <header className="glass border-b border-border sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/dashboard" className="flex items-center space-x-3 text-slate-400 hover:text-white transition-colors">
              <ArrowLeft className="w-5 h-5" />
              <span className="hidden sm:inline">Dashboard</span>
            </Link>
            <div className="flex items-center space-x-3">
              <Shield className="w-6 h-6 text-blue-500" />
              <span className="font-semibold font-['Outfit']">Asistente de Contratos</span>
            </div>
            <div />
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ContractRecommendation />
      </main>
    </div>
  );
};

export default RecommendPage;
